<template>
  <button type="button" class="share__icon" @click="bounceAndEmit">
    <slot />
  </button>
</template>

<script>
export default {
  methods: {
    bounceAndEmit() {
      this.$emit('click')
    }
  }
}
</script>
